import formatUnits from '#/utils/formatUnits';
import { BigNumberish, ethers } from 'ethers';
import { Tooltip } from './v2/tooltip';

interface Props {
  value?: BigNumberish | null;

  decimals?: BigNumberish;
  maxDecimalDigits?: number;
  suffix?: string | null;
  tooltip?: boolean;
}

export default function EthereumFormatUnits({
  value,
  decimals = 18,
  maxDecimalDigits = 5,
  suffix = 'ETH',
  tooltip = false,
}: Props) {
  return value != null ? (
    <Tooltip
      content={`${ethers.utils.commify(
        formatUnits(value, decimals)
      )} ${suffix}`}
      disabled={!tooltip}
    >
      {ethers.utils.commify(formatUnits(value, decimals, maxDecimalDigits))}{' '}
      {suffix}
    </Tooltip>
  ) : (
    <>-</>
  );
}
